import { ScrollContainer } from 'app/layout/dashboardLayout/BoxLayout';
import { uniqBy } from 'lodash';

import { useState } from 'react';
import { SelectedQuestionnaireDocuments } from './SelectedQuestionnaireDocuments';
import { SelectPreviouslyUploadedDocuments } from './SelectPreviouslyUploadedDocuments';
import { UploadNewQuestionnaireDocuments } from './UploadNewQuestionnaireDocuments';

export interface QuestionnaireDocument {
  url: string;
  title: string;
  id?: number; // old files do not have an id
}

export interface IUploadFormProps {
  projectId: number;
  value?: QuestionnaireDocument[];
  view: 'upload-documents' | 'select-previously-uploaded';
  onChange: (documents: QuestionnaireDocument[]) => void;
}
export const UploadForm = ({
  onChange,
  projectId,
  value,
  view,
}: IUploadFormProps) => {
  const [selected, setSelected] = useState<QuestionnaireDocument[]>(
    () => value || [],
  );

  return (
    <div className="h-full flex-1 overflow-y-auto grid grid-cols-3 gap-3 p-4">
      <div className="col-span-2 overflow-y-auto">
        {view === 'upload-documents' && (
          <UploadNewQuestionnaireDocuments
            projectId={projectId}
            onUpload={(uploaded) =>
              setSelected((selected) => {
                const newSelected = selected.concat(uploaded);
                onChange(newSelected);
                return newSelected;
              })
            }
          />
        )}

        {view === 'select-previously-uploaded' && (
          <SelectPreviouslyUploadedDocuments
            projectId={projectId}
            value={[]}
            onChange={(prev) => {
              setSelected((selected) => {
                const newSelected = uniqBy(selected.concat(...prev), 'url');
                onChange(newSelected);
                return newSelected;
              });
            }}
          />
        )}
      </div>

      <div className="col-span-1 overflow-y-auto">
        <SelectedQuestionnaireDocuments
          value={selected}
          onChange={(updated) => {
            setSelected(updated);
            onChange(updated);
          }}
        />
      </div>
    </div>
  );
};
